import React, { Component } from 'react';
import mapboxgl from 'mapbox-gl';
import mapStyles from '../utils/Style';
class App extends Component {
    constructor(props){
        super(props);
    }
    componentDidMount(){
        mapboxgl.accessToken = 'pk.eyJ1Ijoibm91cGhhbHBncyIsImEiOiJjajV0YXZxdDIxZmtjMzNwajRjaHo3dzBmIn0.JRJtyy5Epzx6QKmfy5FN7g';
        const map = new mapboxgl.Map({
            container: 'map',
            maxZoom: 18,
            minZoom: 12,
            zoom: 15.2,
            center: [55.67900, 24.19760],
            style: mapStyles,
            hash: false
        });

        map.addControl(new mapboxgl.NavigationControl());
        map.dragRotate.disable();
        
        this.props.setMap(map);
        this.renderMap(map)
    }

    renderMap(mapData){
        let geoData = this.props.geoData,
            map = mapData,
            iconsArr = [],
            categoryArr = [];

        map.on('load', function() {
        
            map.addSource("points", {
                "type": "geojson",
                "data": geoData
            });

            

            geoData.features.map((feature, i) => {
                var symbol = feature.properties['icon'];
                map.loadImage(require('../images/' + symbol + '.png'), function(error, image) {
                    
                    if (error) throw error;
                    if (!iconsArr.includes(symbol)) {
                        map.addImage(symbol, image);
                        iconsArr.push(symbol);
                    }
                    if (!map.getLayer('uaeu')) {
                        map.addLayer({
                            "id": 'uaeu',
                            "type": "symbol",
                            "source": "points",
                            "layout": {
                                "visibility": "visible",
                                "icon-image": "{icon}",
                                "icon-size": 0.7,
                                "icon-allow-overlap": true,
                            }
                        });
                    }
                });
            });

            
        });    
    }

    render(){
        return(
            <div id="map"></div>
        )
    }
}

export default App;




// WEBPACK FOOTER //
// ./src/components/Map.js